export class WorldAssignmentTrackingConstants {
    public static NETWORK_XML_START: string = "NETWORK_XML_START";
    public static NETWORK_XML_END: string = "NETWORK_XML_END";
    public static ZONE_XML_START: string = "ZONE_XML_START";
    public static ZONE_XML_END: string = "ZONE_XML_END";
    public static BRANCH_XML_START: string = "BRANCH_XML_START";
    public static BRANCH_XML_END: string = "BRANCH_XML_END";
    public static COUNTRY_XML_START: string = "COUNTRY_XML_START";
    public static COUNTRY_XML_END: string = "COUNTRY_XML_END";
}
